import { JitsiMeeting } from "@jitsi/react-sdk";
import {
  ArrowDown2,
  ArrowForward,
  Book,
  Calendar,
  Setting2,
  Setting3,
  Setting4,
  Setting5,
  Timer1,
} from "iconsax-react";
import { useContext, useState } from "react";
import { UserContext } from "../../context/UserContext";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { frontUrl } from "../../../../../axios/instance";

export default function TeleDashboard() {
  const roomName = "denningandvictoriaforever";

  const { user } = useContext(UserContext);

  const { consultations, doctor } = useLoaderData();

  const link = `${frontUrl}/telemedicine/meeting/invite/instant/${user?.id}`;

  const [meetingModalOpen, setMeetingModalOpen] = useState(false);

  const navigate = useNavigate();

  function startMeetingTest() {
    setMeetingModalOpen(true);
  }

  function handleCopy(text) {
    navigator.clipboard.writeText(text);
    toast.success("Invite link copied");
  }

  function handleInstantJoin() {
    navigate("/dashboard/telemedicine/meeting/instant", {
      state: {
        doctor_id: user?.id,
        channel_name: generateInstantChannel(user?.id),
      },
    });
  }

  return (
    <div className="p-3">
      <div className="space-y-6 p-6">
        <div>
          <div className="text-[32px]">Welcome, {user?.firstname}</div>
          <div className="text-gray-600 text-[14px]">
            To invite someone to your waiting room, share this link
          </div>
        </div>

        <div className="flex gap-1">
          <input
            className="bg-gray-200 rounded-[3px] p-3 w-[350px] text-gray-500 text-[14px]"
            disabled
            value={link}
          />
          <div className="flex gap-2">
            <button
              onClick={() => handleCopy(link)}
              className="px-6 border border-[#00b0ad] bg-[#00b0ad] text-white text-[14px] font-medium rounded-[3px]"
            >
              Copy
            </button>
            <button
              onClick={handleInstantJoin}
              className="px-6 flex items-center gap-2 border border-[#00b0ad] bg-white text-[#00b0ad] text-[14px] font-medium rounded-[3px]"
            >
              Join now <ArrowForward size={16} />
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 p-6 gap-3">
        <div
          onClick={() => navigate("/dashboard/telemedicine/waiting_room")}
          className="col-span-3 cursor-pointer text-[#00b0ad] bg-[#00b0ad22] p-4 rounded-[6px] flex flex-col justify-center items-center gap-4"
        >
          <Timer1 size={36} variant="Bold" />
          <div className="font-medium text-[14px]">Manage Queue</div>
        </div>
        <div
          onClick={() => navigate("/dashboard/telemedicine/history")}
          className="col-span-3 cursor-pointer text-[#00b0ad] bg-[#00b0ad22] p-4 rounded-[6px] flex flex-col justify-center items-center gap-4"
        >
          <Book size={36} variant="Bold" />
          <div className="font-medium text-[14px]">Meeting History</div>
        </div>
        <div
          onClick={() => navigate("/dashboard/telemedicine/calendar")}
          className="col-span-3 cursor-pointer text-[#00b0ad] bg-[#00b0ad22] p-4 rounded-[6px] flex flex-col justify-center items-center gap-4"
        >
          <Calendar size={36} variant="Bold" />
          <div className="font-medium text-[14px]">Calendar</div>
        </div>

        <div
          onClick={() => navigate("/dashboard/telemedicine/calendar")}
          className="col-span-3 cursor-pointer text-[#00b0ad] bg-[#00b0ad22] p-4 rounded-[6px] flex flex-col justify-center items-center gap-4"
        >
          <Calendar size={36} variant="Bold" />
          <div className="font-medium text-[14px]">Prescription</div>
        </div>
      </div>

      <div className="px-6">
        <div className="font-medium text-md mb-2">Recent Consultations</div>

        <div className="max-h-[70vh] rounded-[6px] w-full border overflow-y-scroll scrollbar-hide">
          <table className="w-full relative whitespace-nowrap">
            <thead className="">
              <tr className="uppercase h-14 font-bold bg-[#f1f1f1] text-gray-700 text-[12px]">
                <td className="px-6 py-4 cursor-pointer hover:text-primary duration-300">
                  #{" "}
                </td>
                <td className="px-6 py-4">ID</td>
                <td className="px-6 py-4 cursor-pointer hover:text-primary duration-300">
                  Title{" "}
                </td>
                <td className="px-6 py-4 cursor-pointer hover:text-primary duration-300">
                  Patient{" "}
                </td>
                <td className="px-6 py-4 cursor-pointer hover:text-primary duration-300">
                  Doctor{" "}
                </td>
                <td className="px-6 py-4 cursor-pointer hover:text-primary duration-300">
                  {doctor.access === "admin" ? "Amount" : "Payment Status"}
                </td>
                <td className="px-6 py-4 cursor-pointer hover:text-primary duration-300">
                  Status{" "}
                </td>
                <td className="px-6 py-4" onClick={() => handleSort("date")}>
                  Date Created{" "}
                </td>
              </tr>
            </thead>

            <tbody>{displayConsultations()}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const displayConsultations = () => {
  const { consultations, doctor } = useLoaderData();

  const pendingConsultations = consultations.filter(
    (consultation) => consultation.meeting_status === "pending",
  );

  if (pendingConsultations.length < 1) {
    return (
      <tr>
        <td className="h-14 px-3 text-[14px] font-normal text-gray-600">
          No recent consultation
        </td>
      </tr>
    );
  }

  if (doctor.access === "admin") {
    // If the doctor is an admin, display all *pending* consultations
    return pendingConsultations.slice(0, 5).map((consultation, index) => (
      <tr
        key={consultation.id}
        className="h-14 text-[14px] font-normal border-b"
      >
        <td className="px-6 py-4">{index + 1}</td>
        <td className="px-6 py-4">
          <Link
            to={`/dashboard/telemedicine/consultations/${consultation.id}`}
            className="underline text-primary"
          >
            {consultation.id}
          </Link>
        </td>
        <td className="px-6 py-4">{consultation.treatment?.title || "N/A"}</td>
        <td className="px-6 py-4">
          {consultation.patient
            ? `${consultation.patient.lastname} ${consultation.patient.firstname}`
            : "N/A"}
        </td>
        <td className="px-6 py-4 capitalize">{consultation.doctor_name}</td>
        <td className="px-6 py-4 capitalize">
          ${+consultation.amount.toLocaleString()}
        </td>
        <td className="px-6 py-4 capitalize">{consultation.meeting_status}</td>
        <td className="px-6 py-4">
          {new Date(consultation.created_at).toLocaleDateString()}
        </td>
      </tr>
    ));
  } else {
    // If the doctor is not an admin, display only *their pending* consultations
    const filteredConsultations = pendingConsultations.filter(
      (consultation) => consultation.doctor_id === doctor.id,
    );

    return filteredConsultations.map((consultation, index) => (
      <tr
        key={consultation.id}
        className="h-14 text-[14px] font-normal border-b"
      >
        <td className="px-6 py-4">{index + 1}</td>
        <td className="px-6 py-4">
          <Link
            to={`/dashboard/telemedicine/consultations/${consultation.id}`}
            className="underline text-primary"
          >
            {consultation.id}
          </Link>
        </td>
        <td className="px-6 py-4">{consultation.treatment?.title || "N/A"}</td>
        <td className="px-6 py-4">
          {consultation.patient
            ? `${consultation.patient.lastname} ${consultation.patient.firstname}`
            : "N/A"}
        </td>
        <td className="px-6 py-4 capitalize">{consultation.doctor_name}</td>
        <td className="px-6 py-4 capitalize">{consultation.payment_status}</td>
        <td className="px-6 py-4 capitalize">{consultation.meeting_status}</td>
        <td className="px-6 py-4">
          {new Date(consultation.created_at).toLocaleDateString()}
        </td>
      </tr>
    ));
  }
};

export function generateInstantChannel(uid) {
  return `instant_meeting_with_doc_id_${uid}`;
}
